<template>
  <div>
    <router-view></router-view>
    <BackTop />
  </div>
</template>

<script>
import BackTop from "@/components/BackTop"
export default {
  name: 'App',
  components: {
    BackTop
  }
}
</script>

<style>

</style>
